import './App.css'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Main from './Pages/Main/Main'
import AuthComplete from './Pages/AuthComplete/AuthComplete'
import { getBrandName, isDevEnv } from './Utils'
import DatadogService from './Services/DatadogService'
import LaunchRules from './Services/LaunchRules'
import OneTrust from './Services/OneTrust'
import { useEffect } from 'react'
import Config from './Data/Config.json'

function App() {
    const brand = getBrandName()
    const homeRoutes = ['/', ...Config.supportedDevices.map((device: string) => `/${device}`)]
    useEffect(() => {
        DatadogService.init(isDevEnv)

        OneTrust.init(brand).catch((error: unknown) => {
            DatadogService.trackError(error, { service: 'OneTrust' })
        })
        LaunchRules.init(isDevEnv, brand).catch((error: unknown) => {
            DatadogService.trackError(error, { service: 'LaunchRules' })
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <Router>
            <Routes>
                {homeRoutes.map((path: string) => (
                    <Route key={path} path={path} element={<Main brandName={brand} />} />
                ))}
                {homeRoutes.map((path: string) => {
                    const completeRoutePath = `${path}/complete`
                    return (
                        <Route
                            path={completeRoutePath}
                            key={completeRoutePath}
                            element={<AuthComplete brandName={brand} />}
                        />
                    )
                })}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Router>
    )
}

export default App
